import {
  React,
  Component,
  PropTypes,
} from 'imports/CommonImports';

import {
  GreyColor1,
  GreyColor2,
  SuccessColorLight,
  PrimaryColor1,
  ShadowColor,
} from 'imports/DesignImports';

import {
  Paper,
  SelectField,
  MenuItem,
} from 'material-ui';

import ReactHighcharts from 'react-highcharts';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    minWidth: '20em',
  },
  header: {
    marginLeft: '1em',
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}

class ProjectDistributionPerAreaGraph extends Component {
  constructor(props){
    super(props);
    this.state = {
      now: new Date(Date.now()),
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1, ShadowColor,],
      areas: Array.from(new Set(props.data.map(project => project.area))),
      selectedAreaIndex: 0,
    }
  }

  render() {
    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <p style={styles.header}><b>Distribución del aporte económico por proyecto por área</b></p>
            <div style={styles.selectContainer}>
              Area:
              <SelectField value={this.state.selectedAreaIndex} onChange={this.changeAreaSelector} style={{width: 'auto', marginLeft: '1em'}} underlineStyle={{display: 'none'}}>
                {this.state.areas.map((area, i) => {
                  return <MenuItem key={i} value={i} primaryText={area}/>
                })}
              </SelectField>
            </div>
        </div>
        <ReactHighcharts config={this.config()} ref="chart" style={{minHeight:"400px"}}/>
      </Paper>
    );
  }

  changeAreaSelector = (event, index, value) => {
    this.setState({
      selectedAreaIndex: index
    })
  }

  config = () => {
    return {
      chart: {
          type: 'area',
          backgroundColor: GreyColor2,
      },
      title: {
          text: ''
      },
      xAxis: {
          categories: [this.state.now.getFullYear() - 1, this.state.now.getFullYear(), this.state.now.getFullYear() + 1],
          tickmarkPlacement: 'on',
          title: {
              enabled: false
          }
      },
      yAxis: {
          title: {
              text: this.props.indicator + ' (MM' + this.props.currency + ')',
          },
          labels: {
              formatter: function () {
                  return this.value / 1000;
              }
          }
      },
      tooltip: {
          valueSuffix: ' ' + this.props.currency,
      },
      plotOptions: {
          area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                  lineWidth: 1,
                  lineColor: '#666666'
              }
          }
      },
      series: this.props.data.filter(data => data.area === this.state.areas[this.state.selectedAreaIndex]).map((data) => {return {name: data.name, data: data.values}}),
    }
  }
}

ProjectDistributionPerAreaGraph.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array,
  indicator: PropTypes.string,
  currency: PropTypes.string,
}

ProjectDistributionPerAreaGraph.defaultProps = {
  style: {},
  data: [
    {name: 'Digitalización de procesos financieros', values: [100, 200, 300], area: 'Finanzas'},
    {name: 'Facturación electrónica 2.0', values: [150, 220, 280], area: 'Finanzas'},
    {name: 'Producción en seco de fruta', values: [200, 300, 400], area: 'Operaciones'},
    {name: 'Seguimiento de la producción con uso de blockchain', values: [180, 290, 400], area: 'Operaciones'},
    {name: 'Riego automatizado para campos en pendiente', values: [300, 400, 500], area: 'Innovación'},
    {name: 'Uso de drones para vigilancia de campos', values: [210, 370, 440], area: 'Innovación'},
    ],
  indicator: 'EBITDA',
  currency: 'CLP',
}
export default ProjectDistributionPerAreaGraph;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProjectDistributionPerAreaGraph.js